import { IOGImage } from '@lemon8/web-app-shared/ssr';
import { useParams } from '@remix-run/react';
import { useAtomValue } from 'jotai';
import { loadable } from 'jotai/utils';
import { $PoiPost } from 'shared/atoms';
import { ArticleDetailUtil } from 'shared/models';

export const usePoiCover: () => IOGImage | null = () => {
  const { poi_id: poiId = '' } = useParams<{ poi_id: string }>();

  const loadablePoiPosts = useAtomValue(loadable($PoiPost(poiId)));

  if (loadablePoiPosts.state !== 'hasData' || !loadablePoiPosts.data) {
    return null;
  }

  const { items: poiPostItems } = loadablePoiPosts.data;

  if (poiPostItems.length > 0) {
    const firstArticle = poiPostItems[0];
    const image = ArticleDetailUtil.getCoverImage(firstArticle);
    return {
      url: image.shareCardCoverImage || image.url,
      width: image.width,
      height: image.height,
    };
  } else {
    return null;
  }
};
